<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4>Request new Sender ID:</h4>
    <button mat-dialog-close mat-icon-button>
      <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="dialog__spinner">
      <div *comSpinner="isFetching; color: 'primary'; diameter: 30"></div>
    </div>

    @if (!showSuccessSummary) {
      <form [formGroup]="senderIdForm" (ngSubmit)="handleFormSubmit()" *ngIf="!isFetching">
        <mat-stepper linear #stepper>
          @if (data.showOwnerSelect) {
            <mat-step [stepControl]="getFormControl('sido')" errorMessage="Sender ID Text is required">
              <ng-template matStepLabel>Request Sender IDs owner</ng-template>
  
              <mat-radio-group [formControl]="getFormControl('owner')" class="dialog__radio-group">
                <mat-radio-button [value]="false">My own Sender ID</mat-radio-button>
                <mat-radio-button [value]="true" class="dialog__radio-button">
                  On behalf of a Sender ID Owner
  
                  <mat-form-field>
                    <mat-label>Sido owner</mat-label>
                    <input
                      [formControl]="getFormControl('sido')"
                      type="text"
                      matInput
                      [matAutocomplete]="auto"
                      placeholder="Type at least 2 characters..."
                    />
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      @for (sido of filteredSidoOptions$ | async; track sido) {
                        <mat-option [value]="sido">{{ sido.organisationName }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-radio-button>
              </mat-radio-group>
  
              <div class="dialog__buttons-container">
                <div></div>
                <div>
                  <button mat-raised-button matStepperNext type="button">Next</button>
                </div>
              </div>
            </mat-step>
          }
          <mat-step [stepControl]="textsControlsArray" errorMessage="Sender ID Text is required">
            <ng-template matStepLabel>Request Sender IDs texts</ng-template>
            <p>You can request new Sender IDs here.</p>
            <p>
              After submitting, ComReg will review your application.
            </p>
            <p>
              Sender IDs will have the status 'Pending' until they are 'Approved' or 'Rejected' by ComReg.
            </p>
            <si-sender-ids-form [thirdParties]="thirdParties" (thirdPartiesChanged)="handleThirdPartiesChanged($event)"></si-sender-ids-form>
            <div class="dialog__buttons-container">
              <div>
                @if (data.showOwnerSelect) {
                  <button mat-button matStepperPrevious type="button">Back</button>
                }
              </div>
              <div>
                <button mat-raised-button matStepperNext type="button">Next</button>
              </div>
            </div>
          </mat-step>
  
          <mat-step [stepControl]="opaControlsArray" errorMessage="At least 1 OPA must be selected">
            <ng-template matStepLabel>Request new Sender IDs OPA</ng-template>
            <si-sender-ids-opas-form [formArray]="opaControlsArray" [opas]="opasList" [disabled]="isSaving"></si-sender-ids-opas-form>
            <mat-error *ngIf="serverErrorMessage !== null">{{serverErrorMessage}}</mat-error>
            <div class="dialog__buttons-container">
              <div>
                <button mat-button matStepperPrevious [disabled]="isSaving" type="button">Back</button>
              </div>
              <div>
                <button mat-raised-button matStepperNext [disabled]="isSaving" (click)="handleRequestButtonClick()">Request</button>
              </div>
            </div>
          </mat-step>
        </mat-stepper>
      </form>
    }
    
    @if (showSuccessSummary) {
      <div class="summary">
        <h3>Sender ID requested successfully</h3>
        <br>
        Once approved, it may take up to five working days for your SenderID registration to come into effect with all SMS providers.
        <br>
      </div>
    }
      
  </mat-dialog-content>
</div>
